<app-my-json-ld [itemLD]="json1"></app-my-json-ld>
<app-my-json-ld [itemLD]="json2"></app-my-json-ld>

<app-header [url]="'cuet'" [pageType]="'cuet'"></app-header>
<div class="franchise-header">
    <div class="container container_bigscreen">
        <div class="row justify-content-center">
            <div class="col-md-11">
                <div class="row">
                    <div class="col-md-6">
                        <div class="text middle">
                            <h1>Best CUET Online Coaching in India
                                <span>iQuanta</span>
                            </h1>
                            <p>The most comprehensive online program designed by the best faculties in the industry.</p>
                            <p>Enroll in the best <strong>CUET online coaching</strong> in India with iQuanta. Get expert guidance and comprehensive study materials for the CUET Course 2026 to ensure your success in the CUET exam.</p>
                            <div class="">

                                <div class="home-buttons">
                                    <ul class="nav">
                                        <li>
                                            <button class="pushable pushone" (click)="gotocourse()">
                                                <div class="front">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/new-home/package.png"
                                                            alt="Icon"></span>
                                                    Enrol Now
                                                </div>
                                            </button>



                                        </li>

                                        <li>
                                            <button class="pushable pushtwo " (click)="enquiryForm1()">
                                                <div class="front">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/new-home/books.png"
                                                            alt="Icon"></span> Free Counselling
                                                </div>
                                            </button>
                                        </li>


                                        <li>
                                            <button class="pushable pushthree " [routerLink]="'/cuet-mock-test'">
                                                <div class="front">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/new-home/mock.png"
                                                            alt="Icon"></span> Cuet Mocks
                                                </div>
                                            </button>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="socail-group d-flex">
                                <div class="fb-card d-flex" (click)="whatsappLink()">
                                    <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                    <div>
                                        <h4>CUET Student Group</h4>
                                        <h6>4000+ Members</h6>
                                    </div>
                                </div>
                                <div class="whatsapp" (click)="fbLink()">
                                    <i class="fa fa-facebook" aria-hidden="true"></i>
                                </div>
                                <div class="youtube" (click)="youtubeLink()">
                                    <i class="fa fa-youtube-play" aria-hidden="true"></i>
                                </div>
                                <div class="insta" (click)="instaLink()">
                                    <i class="bi bi-instagram"></i>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="col-md-6 pl-md-5">
                        <div class="img-franchase">
                            <div class="toppers-image-card" *ngFor="let slide of thumbnail">
                                <div class="img">
                                    <img [src]="slide.img" alt="CUET Online Coaching">
                                    <svg (click)="playVideo(slide)" xmlns="http://www.w3.org/2000/svg" width="50"
                                        height="50" fill="currentColor" class="bi bi-play-circle-fill"
                                        viewBox="0 0 16 16">
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                    </svg>
                                </div>
                            </div>
                            <!-- <iframe src="https://www.youtube.com/embed/paCLHSMBDYI?autoplay=1&mute=1" width="455"
                                height="267" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
                                allowfullscreen="true" allow="autoplay" data-ready="true"></iframe> -->
                        </div>

                        <div class="instructor d-flex align-items-center">
                            <span>Instructed by</span>
                            <div class="img">
                                <img src="https://media.iquanta.in/ui_images/instructor.png" alt="indrajeet singh">
                            </div>
                            <div class="text ">
                                <h5>Indrajeet Singh</h5>
                                <p>CEO & Founder</p>
                            </div>
                        </div>

                        <div class=" predi-btn">

                            <div class="home-buttons">
                                <ul class="nav">
                                    <li>
                                        <button class="pushable " [routerLink]="'/cuet-college-predictor'">
                                            <div class="front">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/new-dashboard/iim.png"
                                                        alt="Icon"></span>
                                                CUET College Predictor
                                            </div>
                                        </button>



                                    </li>


                                </ul>
                            </div>


                        </div>
                    </div>
                </div>


                <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="deadlines ipmat-table">
                            <div class="table-responsive">
                                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                    <ng-container matColumnDef="exam">
                                        <th mat-header-cell *matHeaderCellDef> exam </th>
                                        <td mat-cell *matCellDef="let element"> {{element.exam}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ApplicationStarts">
                                        <th mat-header-cell *matHeaderCellDef> Application Dates </th>
                                        <td mat-cell *matCellDef="let element">{{element.ApplicationDates ?
                                            element.ApplicationDates:'To be Notified'}}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="ApplicationEnds">
                                        <th mat-header-cell *matHeaderCellDef> ExamDate </th>
                                        <td mat-cell *matCellDef="let element"> {{element.ExamDate ?
                                            element.ExamDate:'To be Notified'}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ExamDate">
                                        <th mat-header-cell *matHeaderCellDef> Syllabus </th>
                                        <td mat-cell *matCellDef="let element"><i class="bi bi-link-45deg"></i>
                                            <a href="{{element.Syllabus}}" target="_blank">{{element.syllbusLink}}</a>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="OfficialWebsite">
                                        <th mat-header-cell *matHeaderCellDef> Official Website </th>
                                        <td mat-cell *matCellDef="let element"><i class="bi bi-link-45deg"></i>
                                            <a href="{{element.OfficialWebsite}}" rel="nofollow" target="_blank">Click Here</a>
                                        </td>
                                    </ng-container>


                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>

                        </div>
                    </div>
                </div> -->
            </div>

        </div>

    </div>


    <!-- <div class="transparant">
        <div class="img">
            <img src="https://media.iquanta.in/ui_images/new-dashboard/transparant2.png" alt="CUET Online Coaching">
        </div>
    </div> -->

</div>

<div class="every-thing">
    <div class="container">
        <div class="tittle">
            <h2>Everything about CUET UG Exam</h2>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <ul class="nav nav-tabs" id="myTab" role="tablist">

                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="What-tab" data-toggle="tab" data-target="#What" type="button"
                            role="tab" aria-controls="cat" aria-selected="false">What is CUET UG?</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Calendar-tab" data-toggle="tab" data-target="#Calendar"
                            type="button" role="tab" aria-controls="Calendar" aria-selected="false">Exam Calendar </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Eligibility-tab" data-toggle="tab" data-target="#Eligibility"
                            type="button" role="tab" aria-controls="Eligibility" aria-selected="false">Eligibility</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Pattern-tab" data-toggle="tab" data-target="#Pattern"
                            type="button" role="tab" aria-controls="Pattern" aria-selected="false">Exam Pattern</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Syllabus-tab" data-toggle="tab" data-target="#Syllabus"
                            type="button" role="tab" aria-controls="Syllabus" aria-selected="false">Syllabus</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="CutOff-tab" data-toggle="tab" data-target="#CutOff"
                            type="button" role="tab" aria-controls="CutOff" aria-selected="false">Cut Off</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Colleges-tab" data-toggle="tab" data-target="#Colleges"
                            type="button" role="tab" aria-controls="Colleges" aria-selected="false">All Colleges</button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="What" role="tabpanel" aria-labelledby="What">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>01</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>What is CUET UG?</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                      <div class="table-content">
                                        <p>CUET UG (Common University Entrance Test – Undergraduate) is a national level entrance examination conducted by National Testing Agency (NTA). CUET UG examination is conducted annually to give a common platform to students who wish to join undergraduate courses at central, state, deemed, and private universities throughout India. With a single entrance to get through, a student can apply to as many universities and courses  as he desires without appearing for separate exams.</p>
                                        <h3>The table below provides a quick overview of the CUET UG 2026 Exam:</h3>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>Particulars</span></td>
                                                    <td><span>Details</span></td>
                                                </tr>
                                                <tr>
                                                    <td>Exam Name </td>
                                                    <td>CUET UG (Common University Entrance Test – Undergraduate)</td>
                                                </tr>
                                                <tr>
                                                    <td>Conducting Authority</td>
                                                    <td>National Testing Agency (NTA)</td>

                                                </tr>
                                                <tr>
                                                    <td>Exam Level</td>
                                                    <td>Undergraduate (UG) and Postgraduate (PG)</td>

                                                </tr>
                                                <tr>
                                                    <td>Exam Frequency</td>
                                                    <td>Annually (Once a year), in May</td>
                                                </tr>
                                                <tr>
                                                    <td>Application Fee</td>
                                                    <td>Depends on subjects chosen and candidate's category Approx: Rs 1200</td>
                                                </tr>
                                                <tr>
                                                    <td>Exam Mode</td>
                                                    <td>Online Computer-Based Test (CBT)</td>
                                                </tr>
                                                <tr>
                                                    <td>Registered Candidates</td>
                                                    <td>Around 13.4 lakh candidates</td>
                                                </tr>
                                                <tr>
                                                    <td>Exam Languages</td>
                                                    <td>English, Hindi, Bengali, Assamese, Odia, Punjabi, Marathi, and others</td>
                                                </tr>
                                                <tr>
                                                    <td>Marking Scheme</td>
                                                    <td>+5 for each correct answer, -1 for each incorrect answer</td>
                                                </tr>
                                                <tr>
                                                    <td>Participating Universities</td>
                                                    <td>230+ including central, state, deemed, and private institutions</td>
                                                </tr>
                                                <tr>
                                                    <td>Official Website </td>
                                                    <td>cuet.nta.nic.in</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <p>To prepare well for CUET 2026, iQuanta offers the best CUET online coaching. Our CUET course will help the students to succeed in their CUET coaching journey with expert guidance, practice tests, and live classes.                                        </p>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Calendar" role="tabpanel" aria-labelledby="Calendar-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>02</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET Exam Calendar</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>Candidates must carefully follow the important dates for the CUET UG 2026 application process and examination schedule to ensure they complete all steps within the given time frame. Adhering to these deadlines is essential for a smooth and successful exam experience.</p>
                                        <h3>CUET Exam Calender</h3>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>Event</span></td>
                                                    <td><span>Date</span></td>
                                                </tr>
                                                <tr>
                                                    <td>Online Application Submission</td>
                                                    <td>February 2026 to March 2026 (Tentative)</td>
                                                </tr>
                                                <tr>
                                                    <td>Fee Payment Mode</td>
                                                    <td>(Credit/Debit Card/Net-Banking/UPI)</td>
                                                </tr>
                                                <tr>
                                                    <td>Announcement of Exam City</td>
                                                    <td>May 2026</td>
                                                </tr>
                                                <tr>
                                                    <td>Admit Card Download</td>
                                                    <td>May 2026</td>
                                                </tr>
                                                <tr>
                                                    <td>Examination Date</td>
                                                    <td>From Mid May 2026</td>
                                                </tr>
                                                <tr>
                                                    <td>Display of Recorded Responses & Answer Keys</td>
                                                    <td>June 2026</td>
                                                </tr>
                                                <tr>
                                                    <td>Result Declaration </td>
                                                    <td>July 2026 End</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="Eligibility" role="tabpanel" aria-labelledby="Eligibility-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>03</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET Eligibility</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>CUET UG Eligibility includes important criteria such as age limit, educational credentials, and university-specific requirements. Before applying for or appearing in the exam, students must know the complete CUET UG Eligibility Criteria.</p>
                                        <p><span>1. Age Limit:</span>  There is no upper age limit CUET UG. But candidates should check the exact age requirement (if there are any) for the university or the institution they are applying to. Usually there is no age limit in most of the universities.</p>
                                        <p><span>2. Educational Qualification:</span> All the candidates who have cleared class 12 or its equivalent exam or those appearing in this year are eligible to apply for CUET UG. The exam qualifying must be from a recognized board/Institution.</p>
                                        <p><span>3. University-Specific Conditions:</span> Every university sets eligibility rules, which include subject combinations, percentage requirements, reservations, and other admission policies. Candidates need to visit the official websites of the universities of which they are applying, and they should confirm that they satisfy all program-wise eligibility criteria.</p>
                                     </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Pattern" role="tabpanel" aria-labelledby="Pattern-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>04</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET Exam Pattern</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>CUET UG 2026 exam pattern has become more systematic for the aspirants. The test will be administered in Computer-Based Test (CBT) mode and will contain Multiple Choice Questions (MCQs). The exam has three sections as follows: Language Test, Domain-specific Subjects(Based upon Class 12 NCERT subjects, same as the one studied in class 12) and General Aptitude Test(Quants, Logical reasoning, GK/Current Affairs). Students can select subjects depending on the course and university they want to apply to. Each section has designated a time limit and it is taken in different slots.</p>
                                        <h3>CUET UG Exam Pattern</h3>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>Section</span></td>
                                                    <td><span>Subjects Covered</span></td>
                                                    <td><span>Number of Questions</span></td>
                                                    <td><span>Duration</span></td>
                                                </tr>
                                                <tr>
                                                    <td>Section I (Language Test)</td>
                                                    <td>13 Languages (e.g., English, Hindi)</td>
                                                    <td>50</td>
                                                    <td>60 minutes</td>
                                                </tr>
                                                <tr>
                                                    <td>Section II (Domain Subjects)</td>
                                                    <td>23 Subjects (Class 12 level as per NCERT)</td>
                                                    <td>50 per subject</td>
                                                    <td>60 minutes per subject</td>
                                                </tr>
                                                <tr>
                                                    <td>Section III (General Test)</td>
                                                    <td>General Aptitude test(Mixed questions including Math till class 8, Logical Reasoning, GK/Current Affairs)</td>
                                                    <td>50</td>
                                                    <td>60 minutes</td>
                                                </tr>
                                            </table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="Syllabus" role="tabpanel" aria-labelledby="Syllabus-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>05</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET Syllabus</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>CUET UG 2026 syllabus is divided into 3 sections as follows: Language Domain Subjects, and General Aptitude Test:</p>
                                        <h3>Section Wise CUET Syllabus</h3>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>Language Subjects</span></td>
                                                    <td>Reading Comprehension (based on Factual, Literary, and Narrative passages), Literary Aptitude, Vocabulary, Grammar</td>
                                                </tr>
                                                <tr>
                                                    <td><span>Domain Subjects</span></td>
                                                    <td>Based on NCERT Class 12 syllabus (subject-specific, chosen by the candidate according to the course/university requirements)</td>
                                                </tr>
                                                <tr>
                                                    <td><span>General Aptitude Test</span></td>
                                                    <td>General Knowledge, Current Affairs, General Mental Ability, Numerical Ability, Quantitative Reasoning (basic arithmetic/algebra/geometry/statistics), Logical and Analytical Reasoning</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="CutOff" role="tabpanel" aria-labelledby="CutOff-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>06</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET Cut Off</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>CUET 2026 cut-off will vary depending on the university, course, and category chosen by the candidate. For top institutions like Delhi University, students generally need a score of 900 or above, while 950+ may be required for admission to the most competitive colleges like SRCC, St. Stephens, Lady Sri Ram college. Knowing your CUET score range can help estimate which type of university you may qualify for. Use iQuanta CUET College predictor to Predict your college according to your CUET Score.</p>
                                        <h3>Here’s a general idea of CUET scores and the level of universities you can target:</h3>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>CUET Score Range</span></td>
                                                    <td><span>Percentile</span></td>
                                                    <td><span>Level of University You May Qualify For</span></td>
                                                </tr>
                                                <tr>
                                                   <td>900 and above</td>
                                                   <td>98 – 99</td>
                                                   <td>Top Central Universities (e.g., Delhi University)</td>
                                                </tr>
                                                <tr>
                                                   <td>750 +</td>
                                                   <td>85 and above</td>
                                                   <td>Good State & Deemed Universities</td>
                                                </tr>
                                                <tr>
                                                    <td>550+</td>
                                                    <td>70 and above</td>
                                                    <td>Private and Mid-level State Universities</td>
                                                 </tr>
                                                 <tr>
                                                    <td>450+</td>
                                                    <td>Below 70</td>
                                                    <td>Low-tier Private Universities or Limited Options</td>
                                                 </tr>
                                            </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="Colleges" role="tabpanel" aria-labelledby="Colleges-tab">
                        <div class="about-cat-wrapper">
                            <div class="tab-content">
                                <div class="top-logo">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/logo2.png"
                                        alt="CUET2026">
                                </div>
                                <div class="row" style="display: flex; align-items: center;">
                                    <div class="col-md-2">
                                        <div class="left">
                                            <h2>07</h2>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="right">
                                                <h3>CUET All Colleges</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-10">
                                        <div class="table-content">
                                        <p>For CUET UG 2026, a wide range of universities and institutions across India will accept CUET scores for undergraduate admissions. This includes Central Universities, as well as State, Deemed, Private Universities, and Other Government Institutions. Below is a breakdown of the number of universities participating in CUET UG 2026:</p>
                                        <div class=" dates-table table-responsive">
                                            <table style="width:100%">
                                                <tr>
                                                    <td><span>Type of University</span></td>
                                                    <td><span>Number of Participating Universities</span></td>
                                                    </tr>
                                                <tr>
                                                   <td>Central University</td>
                                                   <td>48</td>
                                                </tr>
                                                <tr>
                                                   <td>State University</td>
                                                   <td>30</td>
                                                </tr>
                                                <tr>
                                                    <td>Deemed-to-be University</td>
                                                    <td>24</td>
                                                 </tr>
                                                 <tr>
                                                    <td>Private University  </td>
                                                    <td>122</td>
                                                 </tr>
                                                 <tr>
                                                    <td>Other Government Institutions</td>
                                                    <td>60</td>
                                                 </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="how-began">
    <div class="container">
        <div class="tittle">
            <h2>How to Begin CUET Preparation</h2>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10">

                <ul class="nav how-nav-tabs" id="myTab1" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="quantsyllabus-tab" data-toggle="tab"
                            data-target="#quantsyllabus" type="button" role="tab" aria-controls="quantsyllabus"
                            aria-selected="true">LANGUAGE</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="lrdisyllabus-tab" data-toggle="tab" data-target="#lrdisyllabus"
                            type="button" role="tab" aria-controls="lrdisyllabus" aria-selected="false">DOMAIN</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="varcsyllabus-tab" data-toggle="tab" data-target="#varcsyllabus"
                            type="button" role="tab" aria-controls="varcsyllabus" aria-selected="false">GENERAL
                            TEST</button>
                    </li>

                </ul>

                <div class="tab-content" id="myTabContent1">
                    <div class="tab-pane fade show active" id="quantsyllabus" role="tabpanel"
                        aria-labelledby="quantsyllabus-tab">
                        <div class="inner-tabs">
                            <ul class="nav how-nav-tabs mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-Syllabus1-tab" data-toggle="pill"
                                        data-target="#pills-Syllabus1" type="button" role="tab"
                                        aria-controls="pills-Syllabus1" aria-selected="true">Syllabus &
                                        Weightage</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-Strategy1-tab" data-toggle="pill"
                                        data-target="#pills-Strategy1" type="button" role="tab"
                                        aria-controls="pills-Strategy1" aria-selected="false">Strategy</button>
                                </li>

                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-Syllabus1" role="tabpanel"
                                    aria-labelledby="pills-Syllabus1-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/10-66d957997d8e6.webp"
                                                    alt="CUET2026">
                                            </div>

                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>CUET UG Languages Section Strategy</h3>
                                                                    <h4>BREAKING DOWN 'READING COMPREHENSION'<br>It
                                                                        requires the following ingredients.</h4>
                                                                    <table class="ingredients">
                                                                        <tr>
                                                                            <th>Higher retention</th>
                                                                            <th>Fast reading speed</th>
                                                                            <th>Ability to gauge the tone</th>
                                                                            <th>Vocabulary</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>40%</td>
                                                                            <td>30%</td>
                                                                            <td>20%</td>
                                                                            <td>10%</td>
                                                                        </tr>
                                                                    </table>

                                                                    <table class="tips">
                                                                        <tr>
                                                                            <td colspan="2"><strong>To improve these
                                                                                    :</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>1</td>
                                                                            <td>Read 1 to 2 articles from the 250 Genre
                                                                                wise Reading Articles by iQuanta.
                                                                                Available in iConcept Materials section
                                                                                at www.iQuanta.in</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>2</td>
                                                                            <td>Daily solve 1 RC from FREE CUET Mock
                                                                                Tests available at iQuanta website.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colspan="2"><strong>Major things to take
                                                                                    care while solving RCs :</strong>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colspan="2"><strong>Q. How to approach a
                                                                                    passage?</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>1</td>
                                                                            <td>Read & absorb the passage before looking
                                                                                at the questions.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>2</td>
                                                                            <td>Note down important highlights of the
                                                                                paragraph while reading.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colspan="2"><strong>Q. How to attempt
                                                                                    the questions?</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>1</td>
                                                                            <td>Read the questions very carefully</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>2</td>
                                                                            <td>Look out for easy questions</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>3</td>
                                                                            <td>For tougher question, look out for
                                                                                similar options given</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4</td>
                                                                            <td>Do not make assumptions.</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-Strategy1" role="tabpanel"
                                    aria-labelledby="pills-Strategy1-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/9-66d957998728b.webp"
                                                    alt="CUET2026">
                                            </div>

                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                          
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>Section 1: English Language: Syllabus & Weightage</h3>
                                                                    <h4>Total Questions: 50 &nbsp;&nbsp;&nbsp; Maximum Attempt: 40</h4>
                                                                    <table class="main-table">
                                                                        <tr>
                                                                            <th>Reading Comprehension</th>
                                                                            <th>Verbal Ability</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <strong>Reading Comprehension:</strong><br>
                                                                                There will be three types of passages (maximum 300-350 words):<br>
                                                                                i. Factual<br>
                                                                                ii. Narrative<br>
                                                                                iii. Literary
                                                                            </td>
                                                                            <td>
                                                                                <strong>Verbal Ability</strong><br>
                                                                                Rearranging the parts/Parajumbles<br>
                                                                                Choosing the correct word<br>
                                                                                Synonyms and Antonyms<br>
                                                                                Vocabulary
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                            
                                                                    <table class="weightage-table">
                                                                        <tr>
                                                                            <th>Topics</th>
                                                                            <th>Weightage</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>RCs</td>
                                                                            <td>15-20 Questions</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Para Jumbles & One Word Substitutions</td>
                                                                            <td>10-12 Questions</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Grammar</td>
                                                                            <td>10-12 Questions</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Antonyms - Synonyms</td>
                                                                            <td>9-10 Questions</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="lrdisyllabus" role="tabpanel" aria-labelledby="lrdisyllabus-tab">
                        <div class="inner-tabs">
                            <ul class="nav how-nav-tabs mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-Syllabus2-tab" data-toggle="pill"
                                        data-target="#pills-Syllabus2" type="button" role="tab"
                                        aria-controls="pills-Syllabus2" aria-selected="true">Syllabus &
                                        Weightage</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-Strategy2-tab" data-toggle="pill"
                                        data-target="#pills-Strategy2" type="button" role="tab"
                                        aria-controls="pills-Strategy2" aria-selected="false">Strategy</button>
                                </li>

                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-Syllabus2" role="tabpanel"
                                    aria-labelledby="pills-Syllabus2-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/7.jpg"
                                                    alt="CUET2026">
                                            </div>
                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                         
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>Section 2: Domain Subjects (Syllabus & Weightage)</h3>
                                                                    <h4>Total Questions: 50/45<br>To be Attempted: 45/35</h4>
                                                                    <table class="main-table">
                                                                        <tr>
                                                                            <th>Syllabus is almost similar to Class 12 NCERT Books.</th>
                                                                            <th></th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><strong>Domain Subjects List B1:</strong>
                                                                                <ol>
                                                                                    <li>Accountancy/Bookkeeping</li>
                                                                                    <li>Anthropology</li>
                                                                                    <li>Biology/Biotechnology/Biochemistry/Biological Studies</li>
                                                                                    <li>Business Studies</li>
                                                                                    <li>Chemistry</li>
                                                                                    <li>Computer Science/Informatics Practices</li>
                                                                                    <li>Economics/Business Economics</li>
                                                                                    <li>Environmental Studies</li>
                                                                                    <li>Geography/Geology</li>
                                                                                    <li>History</li>
                                                                                    <li>Home Science</li>
                                                                                    <li>Legal Studies</li>
                                                                                    <li>Mathematics</li>
                                                                                    <li>Physics</li>
                                                                                    <li>Political Science</li>
                                                                                    <li>Psychology</li>
                                                                                    <li>Sanskrit</li>
                                                                                    <li>Sociology</li>
                                                                                </ol>
                                                                            </td>
                                                                            <td><strong>List of Domain Subjects B2:</strong>
                                                                                <ol>
                                                                                    <li>Agriculture</li>
                                                                                    <li>Engineering Graphics</li>
                                                                                    <li>Entrepreneurship</li>
                                                                                    <li>Fine Arts/Visual Arts (Sculpture Painting)/Commercial Arts</li>
                                                                                    <li>Knowledge Tradition & Practices India</li>
                                                                                    <li>Mass Media/Mass Communication</li>
                                                                                    <li>Physical Education/NCC/Yoga</li>
                                                                                    <li>Performing Arts
                                                                                        <ol type="i">
                                                                                            <li>Dance - Kathak/Bharatanatyam/Odissi/Kathakali, Kuchipudi/Manipuri)</li>
                                                                                            <li>Drama-Theatre</li>
                                                                                            <li>Music General (Hindustani/Carnatic/Rabindra Sangeet/Percussion/Non-Percussion)</li>
                                                                                        </ol>
                                                                                    </li>
                                                                                    <li>Teaching Aptitude</li>
                                                                                </ol>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-Strategy2" role="tabpanel"
                                    aria-labelledby="pills-Strategy2-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/8.jpg"
                                                    alt="CUET2026">
                                            </div>

                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>CUET UG Domain Subjects Strategy: Boards & Mock Tests</h3>
                                                                    <h4>Approaching any domain subject:</h4>
                                                                    <table class="strategy-table">
                                                                        <tr>
                                                                            <td>1.</td>
                                                                            <td>Invest good amount of time studying for boards & that will have a direct impact on your performance in CUET UG. Since the syllabus is exactly the same, you must maintain short notes.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>2.</td>
                                                                            <td>Boards are theory based exams while CUET is completely MCQ based. Hence mock tests become very important to build good test taking strategies.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>3.</td>
                                                                            <td>This section has 50 questions in each subject out of which maximum 40 in each can be attempted in 45 minutes provided for each section, hence it is a speed based exam, so level of questions remains below moderate.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>4.</td>
                                                                            <td>You must start preparing early or with Class 12 to stay ahead since competition is set to become tougher in the upcoming years as more universities join CUET UG, hence more applicants.</td>
                                                                        </tr>
                                                                    </table>
                                                                    <table class="highlight">
                                                                        <tr>
                                                                            <td>Students are familiar with domain subjects since they study the same in Class 12. Hence taking good number of mocks can make you exam ready.</td>
                                                                        </tr>
                                                                    </table>
                                                                    <table class="highlight">
                                                                        <tr>
                                                                            <td>What to Do: Before you begin the real preparation, Take a FREE MOCK on iQuanta website to check where you stand & then take a FREE expert counselling with our experts on how to enhance your performance.</td>
                                                                        </tr>
                                                                    </table>
                                                                    <table class="highlight">
                                                                        <tr>
                                                                            <td>Try Solving<br>15-20 Questions per day.</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="varcsyllabus" role="tabpanel" aria-labelledby="varcsyllabus-tab">
                        <div class="inner-tabs">
                            <ul class="nav how-nav-tabs mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-Syllabus3-tab" data-toggle="pill"
                                        data-target="#pills-Syllabus3" type="button" role="tab"
                                        aria-controls="pills-Syllabus3" aria-selected="true">Syllabus &
                                        Weightage</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-Strategy3-tab" data-toggle="pill"
                                        data-target="#pills-Strategy3" type="button" role="tab"
                                        aria-controls="pills-Strategy3" aria-selected="false">Strategy</button>
                                </li>

                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-Syllabus3" role="tabpanel"
                                    aria-labelledby="pills-Syllabus3-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/6-66d95a7eb2f34.webp"
                                                    alt="CUET2026">
                                            </div>

                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                       
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>CUET UG GENERAL TEST STRATEGY :</h3>
                                                                    <table>
                                                                        <tr>
                                                                            <th>Step 1</th>
                                                                            <td>Concepts</td>
                                                                            <td>From the Syllabus, clear all the concepts</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Step 2</th>
                                                                            <td>Practice</td>
                                                                            <td>Practice at least 50 questions from each topic.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Step 3</th>
                                                                            <td>Note</td>
                                                                            <td>Note down any new things you've learnt</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Step 4</th>
                                                                            <td>Test Yourself</td>
                                                                            <td>Take assignments or topic-wise tests to gauge your performance.</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Step 5</th>
                                                                            <td>Revision</td>
                                                                            <td>Revise the notes you made</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th></th>
                                                                        </tr>
                                                                    </table>
                                                                    <p><strong>Repeat the same for all the Topics</strong></p>
                                                                    <table class="tips-table">
                                                                        <tr>
                                                                            <th>Expert Tip :</th>
                                                                            <td>No book is enough. Solve as many questions as you can from assignments, daily initiatives and most importantly those which are posted in CUET Preparation - iQuanta group on Facebook. The questions posted in group are randomly distributed across all topics which prepares you substantially for this section. (Do solve even if you don’t comment)</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Doubt Clarification :</th>
                                                                            <td>In case you get any doubt, just post it in CUET Preparation iQuanta group on FB. Doubts get cleared within 30 mins, be it Day or Night.</td>
                                                                        </tr>
                                                                    </table>
                                                                    <p>Doubts get cleared within 30 mins, be it Day or Night.</p>
                                                                    <p>General Test section is completely new for Class 12 students since it is a mixture of GK/Current Affairs, Logical Reasoning, Quantitative Aptitude and has the maximum number of questions, hence this needs dedicated preparation.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-Strategy3" role="tabpanel"
                                    aria-labelledby="pills-Strategy3-tab" tabindex="0">
                                    <div class="how-wraper">

                                        <div class="tab-content-in">
                                            <div class="img desk-none">
                                                <img loading="lazy"
                                                    src=""
                                                    alt="CUET2026">
                                            </div>

                                            <div class="tab-text mobile-none">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="tab-content-logo">
                                                            <img loading="lazy"
                                                                src="https://media.iquanta.in/ui_images/logo2.png"
                                                                alt="CUET2026">
                                                        </div>
                                                        <div class="row justify-content-center">
                                                            <div class="col-md-10">
                                                                <div class="tab-content-table">
                                                                    <h3>Section 3: General Test(Syllabus & Weightage)<br>Total Questions: 60<br>Maximum Attempt: 50</h3>
                                                                    <table>
                                                                        <tr>
                                                                            <th colspan="2">THE MOST IMPORTANT TOPICS<br>(in terms of weightage)</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>GK</td>
                                                                            <td>8-10</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Current Affairs</td>
                                                                            <td>8-10</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Quantitative Aptitude</td>
                                                                            <td>10-15</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Logical & Analytical Reasoning</td>
                                                                            <td>10-15</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>General Mental Ability</td>
                                                                            <td>10-15</td>
                                                                        </tr>
                                                                    </table>
                                                                    <p>General Test in CUET UG can be chosen by student from any stream. It increases your eligibility in most of the universities & their programmes since a lot of universities require score of this section.</p>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="course-section" id="course">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sec-heading d-md-flex justify-content-between">
                    <h2>iQuanta CUET Full Courses</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="course_grid" id="courses-div">
                    <div class="row m-0 courserow">
                        <div *ngFor="let course of coursesArray" class="col-md-4">
                            <app-course-card [course]="course" [pageName]="'cuet'"></app-course-card>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="market-leader">
    <div class="container container_bigscreen">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <h2>iQuanta CUET Results <span>Our Students Broke All Records in CUET 2023 - 2025</span></h2>
            </div>
            <div class="col-md-11">
                <div class="row">
                    <div class="col-md-4">
                        <div class="marker-leader-card mlc ">
                            <h4>30+ <span> Students</span> </h4>
                            <h5>100 Percentilers</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="marker-leader-card">
                            <h4>70+ <span> Students</span> </h4>
                            <h5>99 Percentilers</h5>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="marker-leader-card">
                            <h4>100+ <span> Students</span> </h4>
                            <h5>95 Percentilers</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="student-reviews" id="results-sec">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>Our CUET Topper Reviews</h2>
            </div>
            <div class="col-md-7 ">
                <div class="row">
                    <div class="col-md-6" *ngFor="let review of reviews" (click)="changeReview(review)">
                        <div class="review-card" [ngClass]="{'active_review': review.title == selectedReview?.title}">
                            <div class="review-header">
                                <img [src]="review.img" alt="CUET Topper Reviiew">
                                <h6>{{review.title}}</h6>
                            </div>
                            <h6>{{review?.percentage}}</h6>
                            <p>{{review.text}}...</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-5 custom5 sticky-top">
                <div class="review-full sticky-top">
                    <div class="review-video">
                        <img [src]="selectedReview?.img" alt="CUET Topper Reviiew">
                    </div>
                    <div class="text">
                        <h3>{{selectedReview?.title}}</h3>
                        <p>{{selectedReview?.percentage}}</p>
                        <p>{{selectedReview?.long_description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="success-stories">
    <div class="topers-feedback">
        <div class="container">
            <div class="head">
                <h2>iQuanta CUET UG Topper’s Feedback</h2>
            </div>

            <div class="topper-images">
                <div class="logo-slider3">
                    <div>
                        <div class="feedback-img" *ngFor="let slide of toppersImg">
                            <img [src]="slide" alt="CUET UG Toppers Feedback">

                        </div>
                    </div>
                    <div>
                        <div class="feedback-img" *ngFor="let slide of toppersImg">
                            <img [src]="slide" alt="CUET UG Toppers Feedback">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="b-schools">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sec-title">
                    <h2>Top CUET Universities in India</h2>
                    <h6>Ranking, Placements and Comparison</h6>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="mobile-none">
                    <div class="arrows d-flex nav justify-content-end ">
                        <button (click)="previous_slide1()" class="prev1 hide"><i class="fa fa-angle-left"></i></button>
                        <button (click)="next_slide1()" class="next1"><i class="fa fa-angle-right"></i></button>
                    </div>
                </div>

                <div class="swipe desk-none">
                    <span>Swipe</span>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        enable-background="new 0 0 60 30" height="25px" id="Layer_1" version="1.1" viewBox="0 0 60 30"
                        width="55px" xml:space="preserve">
                        <g>
                            <g>
                                <polygon
                                    points="56,10 53.439,10 56.641,14 50,14 50,16 56.641,16 53.439,20 56,20 60,14.999    " />
                                <polygon
                                    points="4,20 6.562,20 3.361,16 10,16 10,14 3.361,14 6.562,10 4,10 0,15.001    " />
                                <g>
                                    <path
                                        d="M16,16c-0.551,0-1-0.448-1-1c0-8.271,6.73-15,15.002-15C38.271,0,45,6.729,45,14.999c0,0.552-0.447,1-1,1      c-0.551,0-1-0.448-1-1C43,7.831,37.168,2,30.002,2C22.832,2,17,7.831,17,15C17,15.552,16.553,16,16,16" />
                                    <path
                                        d="M29.982,19.989c-6.018,0-5.127-7.311-5.127-7.311s1.027-2.315,5.127-2.315s5.17,2.315,5.17,2.315      S35.996,19.989,29.982,19.989 M30,8c-6.283,0-8.113,5.679-8.113,19.004v0.6C24.229,29.114,27.008,30,30,30      c2.994,0,5.773-0.887,8.115-2.396v-0.6C38.115,13.679,36.285,8,30,8" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="carousel-container1">
                    <div class="inner-carousel" id="options">
                        <div class="track1">
                            <div class="card-container1" *ngFor="let bschool of bschoolsInfo">
                                <div class="card" (click)="gotoLink(bschool)">
                                    <img [src]="bschool.image" alt="Top CUET Universities in India" class="img-fluid">
                                    <div class="card-body">
                                        <h3>{{bschool.bschoolName}}</h3>
                                        <h6>Packages: <span>{{bschool.final_palcement}}</span></h6>
                                        <span class="number">{{bschool.id}}</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>


            </div>


        </div>
    </div>
</div>

<div class="why-partner-with">
    <div class="container container_bigscreen">
        <div class="row justify-content-center">
            <div class="col-md-11">
                <div class="row">
                    <div class="col-md-12">
                        <h2>How iQuanta Can Benefit you for CUET Prep?</h2>
                    </div>
                </div>
                <div class="row wpwrow">

                    <div class="col-md-6 pr-2">
                        <div class="partner-card">
                            <div class="check">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                        d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z" />
                                </svg>
                            </div>
                            <h4>Interactive Live Classes</h4>
                            <p>Two way interactive live classes right from the basics with on the spot doubt
                                clarification. If you miss any live class recorded lectures are also available.</p>

                        </div>
                    </div>

                    <div class="col-md-6 pl-2">
                        <div class="partner-card">
                            <div class="check">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                        d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z" />
                                </svg>
                            </div>
                            <h4>24/7 Doubt Clarification</h4>
                            <p>We solve doubts 24/7 within 15 Minutes from any Subject. Live doubt sessions are also
                                conducted.</p>
                        </div>
                    </div>

                    <div class="col-md-6 pr-2">
                        <div class="partner-card">
                            <div class="check">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                        d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z" />
                                </svg>
                            </div>
                            <h4>Syllabus Coverage</h4>
                            <p>Syllabus is covered twice, first through live classes and then in Crash Course</p>
                        </div>
                    </div>

                    <div class="col-md-6 pl-2">
                        <div class="partner-card">
                            <div class="check">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                        d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z" />
                                </svg>
                            </div>
                            <h4>Assignments & Mocks</h4>
                            <p>Highly relevant set of questions provided with detailed solutions and shortcuts. You get
                                a
                                detailed analysis of your performance in the tests.</p>
                        </div>
                    </div>


                </div>


            </div>
        </div>
    </div>
</div>

<div class="how-it-works">
    <div class="container container_bigscreen">
        <div class="row">
            <div class="col-md-12">
                <h2>How It Works?</h2>
            </div>
            <div class="col-md-12">
                <div class="how-it-works-wrapper">
                    <div class="how-it-works-card">
                        <div class="text">
                            <h4>Expert Counselling</h4>
                            <p>Go through an expert training session to understand about your CUET Exam & Colleges to
                                choose the correct program.</p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-works-wrapper opposite">
                    <div class="how-it-works-card">
                        <div class="text opposite">
                            <h4>Get Enrolled</h4>
                            <p>Get enrolled for the CUET course according to the guidance received from our experts and
                                start your journey.</p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-works-wrapper">
                    <div class="how-it-works-card">
                        <div class="text">
                            <h4>Attend Live Classes</h4>
                            <p>Attend CUET live classes regularly to understand the basics and learn their application
                                with on-the-spot doubt clarification.
                            </p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-works-wrapper opposite">
                    <div class="how-it-works-card">
                        <div class="text opposite">
                            <h4>Attempt Assignments </h4>
                            <p>Learn to apply the concepts taught in the live classes by solving the CUET-level
                                questions provided in the assignments.</p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-works-wrapper">
                    <div class="how-it-works-card">
                        <div class="text">
                            <h4>Ask More Doubts</h4>
                            <p>Keep practicing more CUET-level questions and ask all the doubts in iQuanta's Community,
                                which is dedicated to solving the doubts of all the students enrolled in our CUET
                                Course.</p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-works-wrapper opposite">
                    <div class="how-it-works-card">
                        <div class="text opposite">
                            <h4>Revision In Crash Course</h4>
                            <p>The last part of your CUET preparation is revision, to ease this process, iQuanta
                                conducts a 2-month CUET crash course. This Course is free for students who are enrolled
                                in our CUET Online Coaching.</p>
                        </div>
                    </div>
                    <div class="dot"></div>
                </div>
                <div class="how-it-line app">
                    <div class="d2c-inactive-line"></div>
                    <div data-w-id="26afa277-faea-9277-cc4a-f339035950af" class="d2c-active-line">
                    </div>
                </div>

                <!-- <div class="apply-now">
                    <button mat-button>Apply Now</button>
                </div> -->
            </div>
        </div>
    </div>
</div>

<div class="our_faculty">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-11">
                <h2>Our CUET Faculty</h2>

                <div class="row justify-content-center">


                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://media.iquanta.in/ui_images/tarun-tiwari.jpg" alt="Mansi">
                            <h4>Tarun Tiwari</h4>
                            <p>Tarun Tiwari is our GS/ GK faculty with an experience of over 8 years in teaching. He has
                                worked with top notch organisations of the education industry and mentored more than
                                15000
                                students for different competitive exams. He won more than 15 National Quiz Competitions
                                and
                                Gold Medal in Graduation from Allahabad University.
                                He has also faced UPSC interviews twice.
                            </p>
                        </div>
                    </div>




                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://media.iquanta.in/ui_images/ashish-mehta.jpg" alt="Ashish Mehta">
                            <h4>Ashish Mehta</h4>
                            <p>Ashish Mehta is an excellent Quants and Reasoning faculty with more than 8 years of
                                experience. He is also an education counsellor for study in India and Abroad. He has
                                guided more than 10000 students for their better future.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://media.iquanta.in/ui_images/yogesh.jpg" alt="Yogesh Joshi">
                            <h4>Yogesh Joshi</h4>
                            <p>Yogesh Joshi enjoys teaching as well as mentoring MBA aspirants across all major exams in
                                India like CAT, XAT, IIFT & others.
                                He holds a rich experience of 5 years where he has helped thousands of students to
                                realise their dream B-school. He is also deeply involved across all functions at iQuanta
                                like strategy, content research, training and business development.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/vikranth-66d81cf119f5a.webp"
                                alt="Vikrant Kathuria">
                            <h4>Vikrant Kathuria</h4>
                            <p>Vikrant Kathuria is faculty for Verbal Ability and Reading Comprehension (VARC) in our
                                CUET Course. He has scored a perfect 100 percent as well as a 100 percentile in the CAT
                                VARC section. With more than 15 years of teaching experience, Vikrant sir has guided
                                more than thousands of students to get into crack their exams and get into their dream
                                B-school. In his free time, sir loves to take sessions around spoken English, grammar,
                                and personal interviews.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://www.iquanta.in/blog/wp-content/uploads/2024/09/raj-kumar-66d81cf131828.webp"
                                alt="Raj Kumar JHA">
                            <h4>Raj Kumar JHA</h4>
                            <p>Raj Kumar Jha is the faculty for Quants and Higher Mathematics in iQuanta's CUET
                                Coaching. Raj Sir has scored 100 percentile in the CAT Quants section more than 6 times.
                                He has a teaching experience of more than 24 years in CUET and other entrance exams.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://media.iquanta.in/ui_images/Nehil.webp" alt="Nehil Chaudary">
                            <h4>Nehil Chaudary</h4>
                            <p>12+ Years Teaching Experience
                                Cambridge Certified<br>
                                Just as his outstanding personality and aura,
                                Nehil has been an excellent mentor for thousands
                                of students for reading comprehension skills, verbal ability,
                                vocabulory and other prospects of english language asked in various
                                competitive exams. He has a unique charm spell on his students wherein he
                                makes sure that his subject is taught with keen interest and is absorbed by
                                the students with optimal effectiveness.
                            </p>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="our-fac-card">
                            <img src="https://media.iquanta.in/ui_images/Barkha-Bansal.jpeg" alt="Barkha-Bansal">
                            <h4>Barkha-Bansal</h4>
                            <p>Introducing our distinguished CLAT legal faculty, Adv. Barkha Bansal.
                                She is a gold medalist in LL.M and has an impressive track record of
                                academic excellence. With over 3 years of experience in teaching,
                                Ms. Barkha has developed a deep passion for guiding students in
                                the intricate field of legal reasoning.
                            </p>
                        </div>
                    </div>


                </div>

            </div>
        </div>
    </div>
</div>

<div class="more-about-gmat">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <app-card-list [type]="'dark'" [heading]="'Recommended CUET Articles'"
                    [cardList]="cardList"></app-card-list>
            </div>
        </div>
    </div>
</div>

<div class="mockcontent">
    <div class="container">
        <div class="content-box">
            <h2>CUET Online Coaching</h2>
            <p>CUET (Common Undergraduate Admission Test) is a critical examination to get into some of the prestigious
                undergrad colleges in India. CUET is conducted once every year inviting hundreds and lakhs of students
                making it an important yet challenging examination. Choosing the right guidance in such a significant
                journey can be a difficult task. iQuanta comes to rescue with some of the best materials and educators
                available across the sector. Strategically planned content, personally tailored mock tests, innovative
                teaching methods, 24/7 doubt-solving facility, and much more.</p>
        </div>
        <div class="content-box">
            <h2>Why only iQuanta?</h2>
            <p>iQuanta not only brings you exclusive opportunities but also aims for the holistic preparation of the
                candidate. Check out below for the latest features offered by iQuanta CUET Online courses.</p>
            <ul>
                <li>More than 100+ hours of live and recorded lectures designed specifically to maximise the results.</li>
                <li>Specially tailored lesson plans for each section of the paper.</li>
                <li>iQuanta provides AI-based mock tests which can replicate the difficulty level and format of the actual
                    CUET examination.</li>
                <li>The mock tests provided by iQuanta CUET Online courses include a goal tracker and error tracker which
                    help you get a detailed analysis of your performance.</li>
                <li>iQuanta CUET Coaching also comes with the flexibility of learning. You can access recorded lectures on
                    the go anytime anywhere.</li>
                <li>iQuanta believes in quality education at an affordable price. As a result, iQuanta CUET Online courses
                    are made available at an affordable price making it accessible to a wide range of students.</li>
            </ul>
        </div>
        <div class="content-box">
            <h2>What do iQuanta CUET courses offer you?</h2>
            <p>iQuanta CUET Courses offers candidates specially designed features to provide holistic preparation for
                students.</p>
            <ul>
                <li>300+ hours of Live classes for English, General Test & any 3 Domain Subjects.</li>
                <li>iQuanta CUET courses offers Test Series which includes 50+ Full-length Tests, 50+ Sectional Tests and
                    200+ Topic Tests.</li>
                <li>CUET courses also include 5000+ Questions with Detailed video solutions.</li>
                <li>Students can also opt for 1:1 mentorship through the CUET Online coaching.</li>
            </ul>
    
        </div>
        <div class="content-box">
            <h2>Mistakes to avoid during your CUET Preparation</h2>
            <p>Students often commit certain mistakes that can hamper their preparation and lower their chances of getting
                into their desired institutions. Look out for these mistakes and avoid them:</p>
            <ul>
                <li>Students often consume too much time in one section which can result in uneven progress.</li>
                <li>Always try to complete the entire syllabus. Leaving certain parts of the syllabus can result in poor
                    performance.</li>
                <li>While performing mocks, the candidates should neither become overconfident nor should they lose hope
                    based on whether they have scored good or bad.</li>
            </ul>
        </div>
    </div>
</div>

<div class="cuet-features">
    <div class="main-section free-cat-material our-features pt-2">
        <div class="container">
            <div class="row justify-content-center ">
                <div class="col-md-12">
                    <div class="section-header d-flex align-item-center justify-content-center mb-4 pb-3">
                        <h2 class="mb-0 ">iQuanta CUET Features</h2>
                    </div>
                </div>


                <div class="col-md-9 px-sm-0">
                    <div class="row align-items-center d-none d-sm-flex">
                        <div class="col-5">
                            <div class="nav flex-column nav-pills pr-4" id="v-pills-tab1" role="tablist"
                                aria-orientation="vertical">
                                <button (click)="featuresTabChange('dual')"
                                    class="nav-link active text-left px-0 py-1 my-2" id="v-pills-home-tab"
                                    data-toggle="pill" data-target="#v-pills-home" type="button" role="tab"
                                    aria-controls="v-pills-home" aria-selected="true">
                                    <div class="d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                viewBox="0 0 30 34" fill="none">
                                                <path
                                                    d="M29.8846 9.64179C29.8846 9.52902 30 9.41625 30 9.30348C30 9.30348 30 9.30348 30 9.19071C30 9.19071 30 9.19071 30 9.07794C30 8.96517 30 8.85241 30 8.73964C30 8.73964 30 8.73964 30 8.62687C30 8.5141 29.8846 8.40133 29.8846 8.28856C29.7692 8.17579 29.7692 8.17579 29.6538 8.06302L16.9615 0.169154C16.6154 -0.0563848 16.0385 -0.0563848 15.6923 0.169154L0.692308 10.3184L0.576923 10.4312C0.576923 10.4312 0.576923 10.4312 0.461539 10.4312C0.346154 10.5439 0.346154 10.6567 0.230769 10.7695C0.230769 10.7695 0.230769 10.7695 0.230769 10.8823C4.23228e-08 11.2206 0 11.3333 0 11.4461V18.2123V24.9784C0 25.3167 0.230769 25.7678 0.576923 25.8806L13.2692 33.7745C13.5 33.8872 13.7308 34 13.8462 34C14.0769 34 14.3077 33.8872 14.5385 33.7745L29.5385 23.6252C29.7692 23.3997 30 23.1741 30 22.8358C30 22.4975 29.8846 22.1592 29.6538 21.9337C28.6154 20.9187 28.3846 19.4527 29.0769 18.0995L29.8846 16.408C29.8846 16.2952 30 16.1824 30 16.0697V15.9569C30 15.8441 30 15.6186 29.8846 15.5058V15.393C29.8846 15.2803 29.7692 15.1675 29.6538 15.0547C28.6154 14.0398 28.3846 12.5738 29.0769 11.2206L29.8846 9.64179ZM27.2308 15.7313L13.8462 24.7529L2.30769 17.6484V13.5887L13.2692 20.3549C13.5 20.4677 13.7308 20.5804 13.8462 20.5804C14.0769 20.5804 14.3077 20.4677 14.5385 20.3549L26.4231 12.3483C26.3077 13.476 26.5385 14.6036 27.2308 15.7313ZM13.8462 31.5191L2.30769 24.4146V20.3549L13.2692 27.1211C13.5 27.2338 13.7308 27.3466 13.8462 27.3466C14.0769 27.3466 14.3077 27.2338 14.5385 27.1211L26.4231 19.1144C26.3077 20.3549 26.5385 21.5954 27.2308 22.6103L13.8462 31.5191Z"
                                                    fill="#F9F4DD" />
                                            </svg>
                                        </div>
                                        <div class="text">
                                            <h5 class="mb-0 f-bold mr-md-3">Dual Pedagogy</h5>
                                        </div>
                                    </div>
                                </button>
                                <button (click)="featuresTabChange('doubt')" class="nav-link text-left px-0 py-1 my-2"
                                    id="v-pills-profile-tab" data-toggle="pill" data-target="#v-pills-profile"
                                    type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">
                                    <div class="d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                viewBox="0 0 32 42" fill="none">
                                                <path
                                                    d="M30.9145 36.4826V42H0.942406V36.4805C0.942406 34.4335 2.73211 31.9096 4.92013 30.8877L9.78834 28.6039L13.167 35.5501L14.8955 30.9232C15.236 30.9889 15.5754 31.0729 15.929 31.0729C16.2837 31.0729 16.622 30.9889 16.9635 30.9232L18.6037 35.324L21.9136 28.5274L26.9368 30.8845C29.1248 31.9096 30.9145 34.4335 30.9145 36.4826ZM15.9301 28.5263C20.2068 28.5263 23.6738 23.2749 23.6738 18.4617C23.6738 13.6442 20.2079 11.0891 15.9301 11.0891C11.6533 11.0891 8.18852 13.6442 8.18852 18.4617C8.18634 23.2749 11.6533 28.5263 15.9301 28.5263ZM27.4988 16.3491L25.8291 15.7816C26.0048 15.2788 26.1587 14.9105 26.2896 14.6736C26.4206 14.4357 26.6236 14.2472 26.8953 14.1083C27.1681 13.9651 27.5566 13.8779 28.0662 13.8413C28.303 13.8348 28.506 13.8284 28.6795 13.823C28.8487 13.8155 29.0015 13.8004 29.1335 13.7756C29.2656 13.7508 29.3823 13.7045 29.4762 13.6399C29.7272 13.4817 29.928 13.1899 30.0742 12.7678C30.263 12.2294 30.299 11.845 30.1844 11.6145C30.1244 11.453 30.0033 11.3195 29.8167 11.2161C29.629 11.1128 29.3441 10.9965 28.9611 10.8673C28.5278 10.7337 28.2026 10.6551 27.9855 10.6261C27.7738 10.597 27.5948 10.625 27.4518 10.7143C27.2991 10.8263 27.1463 11.0578 26.987 11.4132C26.9891 11.4616 26.9749 11.5295 26.9444 11.6156L26.808 12.0032L25.1394 11.4379C25.4046 10.6777 25.672 10.121 25.9426 9.76787C26.2154 9.41576 26.5199 9.20148 26.8593 9.1218C27.2489 9.0292 27.6515 9.02382 28.063 9.10565C28.4733 9.18748 28.9665 9.32639 29.5416 9.52128C30.8272 9.95845 31.5987 10.4861 31.8573 11.1095C32.0887 11.6576 32.0385 12.4027 31.7078 13.3514C31.4776 14.0082 31.2288 14.4615 30.957 14.7092C30.6853 14.9547 30.3492 15.1162 29.9487 15.1916C29.821 15.2174 29.6082 15.24 29.3059 15.254C29.008 15.268 28.7832 15.2799 28.6348 15.296C28.4853 15.31 28.3358 15.352 28.1797 15.4145C27.9866 15.4715 27.8589 15.5598 27.7934 15.6772C27.7203 15.7709 27.621 15.9938 27.4988 16.3491ZM25.3697 17.0932L27.0393 17.6595L26.4195 19.4373L24.7509 18.8709L25.3697 17.0932ZM4.96487 16.0035L3.55166 16.6151C3.36178 16.1887 3.23846 15.8624 3.17954 15.633C3.12279 15.4037 3.13807 15.1625 3.22755 14.9138C3.31704 14.665 3.51565 14.3797 3.81903 14.0577C3.96744 13.9134 4.09512 13.7907 4.20207 13.6873C4.30683 13.5829 4.39632 13.4849 4.46616 13.3912C4.53491 13.2965 4.58074 13.1995 4.60475 13.1026C4.67132 12.8528 4.62439 12.547 4.46616 12.1928C4.26209 11.7351 4.05474 11.4659 3.84085 11.3863C3.70662 11.3163 3.5473 11.3033 3.36505 11.3464C3.18281 11.3884 2.93072 11.481 2.60552 11.6221C2.24649 11.7922 1.99004 11.9322 1.83507 12.0388C1.68011 12.1465 1.58299 12.2681 1.5437 12.4092C1.51424 12.5686 1.55462 12.8108 1.66702 13.1306C1.69866 13.1597 1.73031 13.2125 1.76305 13.2868L1.90928 13.6173L0.496071 14.23C0.210155 13.5861 0.0475541 13.0725 0.0104505 12.6848C-0.0277444 12.2994 0.038824 11.9828 0.209064 11.7319C0.405495 11.4444 0.659764 11.2075 0.974053 11.0191C1.28725 10.8317 1.68775 10.6336 2.17556 10.4193C3.26356 9.94769 4.07766 9.8357 4.61894 10.0834C5.09583 10.2987 5.5127 10.8091 5.86955 11.6113C6.11836 12.1701 6.22967 12.6062 6.20239 12.9239C6.17511 13.2405 6.05725 13.5398 5.84554 13.8241C5.77788 13.9178 5.65347 14.0577 5.46905 14.2408C5.28462 14.4238 5.15039 14.5649 5.062 14.6618C4.97469 14.7587 4.90267 14.8739 4.84156 15.0064C4.75207 15.1539 4.72261 15.2842 4.75098 15.3983C4.7608 15.5028 4.83065 15.703 4.96487 16.0035ZM4.04383 17.7274L5.45813 17.1136L6.12927 18.62L4.71497 19.2305L4.04383 17.7274ZM14.4568 7.28483L12.8668 6.51709C13.1037 6.03792 13.3023 5.68797 13.4627 5.46723C13.622 5.24865 13.849 5.08498 14.136 4.9773C14.4241 4.86747 14.8235 4.82763 15.3342 4.85455C15.5721 4.87716 15.7762 4.89547 15.9465 4.91269C16.1167 4.92669 16.2706 4.92992 16.4059 4.91915C16.5412 4.91054 16.6601 4.87716 16.7649 4.82871C17.0366 4.69842 17.2724 4.43461 17.4699 4.03405C17.7231 3.52043 17.8104 3.1414 17.7209 2.8959C17.6838 2.729 17.5768 2.5804 17.4044 2.45442C17.232 2.33059 16.9624 2.17877 16.5969 2.00218C16.1822 1.81697 15.8679 1.70176 15.6584 1.64361C15.4499 1.59085 15.2688 1.59516 15.1149 1.66622C14.9501 1.7599 14.7679 1.9731 14.566 2.31013C14.5638 2.35859 14.5409 2.42212 14.4994 2.50718L14.315 2.87759L12.7239 2.11093C13.0829 1.38626 13.4201 0.865104 13.7322 0.548532C14.0487 0.228731 14.3783 0.0521397 14.7253 0.0166062C15.1258 -0.0275415 15.5263 0.0166062 15.9246 0.145819C16.3229 0.278262 16.7966 0.477465 17.3466 0.740198C18.571 1.3335 19.2738 1.95372 19.456 2.60302C19.6153 3.17263 19.4757 3.91129 19.026 4.81794C18.715 5.44247 18.4106 5.86349 18.1083 6.07561C17.8082 6.28666 17.4535 6.40833 17.0443 6.43525C16.9111 6.44602 16.6962 6.44171 16.395 6.41695C16.0949 6.39326 15.8712 6.38034 15.7216 6.37603C15.571 6.37065 15.415 6.39756 15.2524 6.44387C15.056 6.47186 14.9163 6.54616 14.8355 6.65599C14.7515 6.73459 14.6271 6.94672 14.4568 7.28483ZM12.247 7.76614L13.8392 8.53281L12.9989 10.2276L11.4067 9.45883L12.247 7.76614Z"
                                                    fill="#F9F4DD" />
                                            </svg>
                                        </div>
                                        <div class="text">
                                            <h5 class="mb-0 f-bold">24*7 Doubt Solving</h5>
                                        </div>
                                    </div>
                                </button>
                                <button (click)="featuresTabChange('content')" class="nav-link text-left px-0 py-1 my-2"
                                    id="v-pills-messages-tab" data-toggle="pill" data-target="#v-pills-messages"
                                    type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">
                                    <div class="d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                viewBox="0 0 30 30" fill="none">
                                                <path
                                                    d="M20.8421 17.02H17.4919C14.7439 17.02 12.5053 14.908 12.5053 12.2827V9.1C12.5053 8.49867 11.9958 8 11.3474 8H6.45333C2.88702 8 0 10.2 0 14.1307V23.8693C0 27.8 2.88702 30 6.45333 30H15.5467C19.113 30 22 27.8 22 23.8693V18.12C22 17.504 21.4751 17.02 20.8421 17.02Z"
                                                    fill="#F9F4DD" />
                                                <path
                                                    d="M23.5421 0H20.4986H18.8146H14.4424C10.9508 0 8.1236 2.20947 8 6.15277C8.0927 6.15277 8.16994 6.13742 8.26264 6.13742H12.6349H14.3189H17.3624C20.9312 6.13742 23.8202 8.43896 23.8202 12.551V15.5737V19.7318V22.7545C23.8202 22.8466 23.8048 22.9233 23.8048 23C27.25 22.8926 30 20.6217 30 16.6171V13.5944V9.43629V6.41361C30 2.30153 27.111 0 23.5421 0Z"
                                                    fill="#F9F4DD" />
                                                <path
                                                    d="M15.3155 8.20255C14.83 7.77771 14 8.0655 14 8.6548V12.2454C14 13.7529 15.4564 14.9863 17.2417 14.9863C18.3536 15 19.904 15 21.2351 15C21.9085 15 22.253 14.3148 21.7832 13.9036C20.0762 12.4098 17.0381 9.73747 15.3155 8.20255Z"
                                                    fill="#F9F4DD" />
                                            </svg>
                                        </div>
                                        <div class="text">
                                            <h5 class="mb-0 f-bold">Content Relevancy</h5>
                                        </div>
                                    </div>
                                </button>

                                <button (click)="featuresTabChange('peer')" class="nav-link text-left px-0 py-1 my-2"
                                    id="peer-to-peer-tab" data-toggle="pill" data-target="#peer-to-peer"
                                    type="button" role="tab" aria-controls="peer-to-peer" aria-selected="false">
                                    <div class="d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                viewBox="0 0 40 36" fill="none">
                                                <path
                                                    d="M32.5036 6.45161H38.8755C39.5002 6.45161 40 6.96774 40 7.6129V19.3548C40 20.129 39.5002 20.6452 38.8755 20.6452H32.5036C30.3797 20.6452 28.7554 22.3226 28.7554 24.5161V10.3226C28.7554 8.12903 30.3797 6.45161 32.5036 6.45161Z"
                                                    fill="#F9F4DD" />
                                                <path
                                                    d="M17.3859 6.45161H23.7579C25.8818 6.45161 27.506 8.12903 27.506 10.3226V24.5161C27.506 22.3226 25.8818 20.6452 23.7579 20.6452H17.3859C16.7612 20.6452 16.2615 20.129 16.2615 19.4839V7.6129C16.2615 6.96774 16.7612 6.45161 17.3859 6.45161Z"
                                                    fill="#F9F4DD" />
                                                <path
                                                    d="M0.144268 20.129L3.76752 12.6452C3.89246 5.67742 9.51474 0 16.2615 0C19.7598 0 23.0082 1.54839 25.3821 4.12903C24.8823 4 24.3826 3.87097 23.7579 3.87097H17.3859C15.3869 3.87097 13.7627 5.54839 13.7627 7.6129V19.3548C13.7627 21.4194 15.3869 23.0968 17.3859 23.0968H23.7579C24.5075 23.0968 25.0072 23.6129 25.0072 24.3871V32.129C25.0072 32.7742 24.6324 33.2903 24.0077 33.4194L11.5138 36C11.3888 36 11.3888 36 11.2639 36C11.014 36 10.6392 35.871 10.5143 35.7419C10.2644 35.4839 10.0145 35.0968 10.0145 34.7097V29.5484H7.5157C5.39173 29.5484 3.76752 27.871 3.76752 25.6774V21.8065H1.26873C0.893907 21.8065 0.394147 21.5484 0.144268 21.1613C-0.105611 20.7742 0.0193282 20.5161 0.144268 20.129Z"
                                                    fill="#F9F4DD" />
                                            </svg>
                                        </div>
                                        <div class="text">
                                            <h5 class="mb-0 f-bold">Peer to Peer Learning</h5>
                                        </div>
                                    </div>
                                </button>

                            </div>
                        </div>
                        <div class="col-7">
                            <div class="tab-content" id="v-pills-tabContent">
                                <div class="tab-pane fade "
                                    [ngClass]="{'show': featuresTab == 'dual', 'active': featuresTab == 'dual'}"
                                    id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <div class="material-tab-content position-relative ">
                                        <p class="f-light mb-2">Listening passively has certain disadvantages because one is not actively involved in the learning process. And as we have limited attention spans, any student will not be able to listen attentively for an extended period of time.</p>
                                        <p class="f-light mb-0">Hence, short attention spans can be increased through iQuanta's dual pedagogy wherein the focus is not only on teaching theoretical concepts but also application-based learning.
                                        </p>

                                        <div class="d-flex gap-3 mt-3">
                                            <div class="img p-0">
                                                <img class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/dual-pedagogy-01.webp"
                                                    alt="iQuanta Features" loading="lazy">
                                            </div>
                                            <div class="img p-0">
                                                <img class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/home-image/dual-pedagogy-02.webp"
                                                    alt="iQuanta Features" loading="lazy">
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade"
                                    [ngClass]="{'show': featuresTab == 'doubt', 'active': featuresTab == 'doubt'}"
                                    id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                    <div class="material-tab-content position-relative p-0">
                                        <div class="d-flex gap-3 ">
                                            <div class="img p-0">
                                                <img class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/home-image/doubt-solving-24-7.webp"
                                                    alt="iQuanta Features" loading="lazy">
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade"
                                    [ngClass]="{'show': featuresTab == 'content', 'active': featuresTab == 'content'}"
                                    id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                                    <div class="material-tab-content position-relative ">
                                        <p class="f-light mb-0">Content Relevancy is one of the biggest features of iQuanta. Over the years, it has been observed CUET pattern is changing; therefore, in combination with CUET Toppers and iQuanta CUET Faculty, we aim for the most effective content provided to students.</p>
                                        <div class="d-flex gap-3 mt-3">
                                            <div class="img p-0">
                                                <img class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/home-image/content-relevancy.webp"
                                                    alt="iQuanta Features" loading="lazy">
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div class="tab-pane fade"
                                    [ngClass]="{'show': featuresTab == 'peer', 'active': featuresTab == 'peer'}"
                                    id="peer-to-peer" role="tabpanel" aria-labelledby="peer-to-peer-tab">
                                    <div class="material-tab-content position-relative ">
                                        <div class="d-flex gap-3 mt-3 align-items-center">
                                            <div class="w-50 ">
                                                <p class="f-light mb-0">A community is very important as having a dedicated community at one place will provide you with the necessary support for your preparation.</p>
                                            </div>
                                            <div class="img p-0 w-50">
                                                <img class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/home-image/peer-to-peer-learning.webp"
                                                    alt="iQuanta Features" loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row d-block d-sm-none">
                        <div class="col-md-12">
                            <div class="accordion" id="accordionExample2">
                                <div class="card">
                                    <div class="card-header" id="headingDualPedagogy">
                                        <button class="btn btn-link btn-block text-left" type="button"
                                            data-toggle="collapse" data-target="#DualPedagogy" aria-expanded="true"
                                            aria-controls="DualPedagogy">
                                            <div class="d-flex align-items-center">
                                                <div class="icon d-flex align-items-center justify-content-center mr-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                        viewBox="0 0 30 34" fill="none">
                                                        <path
                                                            d="M29.8846 9.64179C29.8846 9.52902 30 9.41625 30 9.30348C30 9.30348 30 9.30348 30 9.19071C30 9.19071 30 9.19071 30 9.07794C30 8.96517 30 8.85241 30 8.73964C30 8.73964 30 8.73964 30 8.62687C30 8.5141 29.8846 8.40133 29.8846 8.28856C29.7692 8.17579 29.7692 8.17579 29.6538 8.06302L16.9615 0.169154C16.6154 -0.0563848 16.0385 -0.0563848 15.6923 0.169154L0.692308 10.3184L0.576923 10.4312C0.576923 10.4312 0.576923 10.4312 0.461539 10.4312C0.346154 10.5439 0.346154 10.6567 0.230769 10.7695C0.230769 10.7695 0.230769 10.7695 0.230769 10.8823C4.23228e-08 11.2206 0 11.3333 0 11.4461V18.2123V24.9784C0 25.3167 0.230769 25.7678 0.576923 25.8806L13.2692 33.7745C13.5 33.8872 13.7308 34 13.8462 34C14.0769 34 14.3077 33.8872 14.5385 33.7745L29.5385 23.6252C29.7692 23.3997 30 23.1741 30 22.8358C30 22.4975 29.8846 22.1592 29.6538 21.9337C28.6154 20.9187 28.3846 19.4527 29.0769 18.0995L29.8846 16.408C29.8846 16.2952 30 16.1824 30 16.0697V15.9569C30 15.8441 30 15.6186 29.8846 15.5058V15.393C29.8846 15.2803 29.7692 15.1675 29.6538 15.0547C28.6154 14.0398 28.3846 12.5738 29.0769 11.2206L29.8846 9.64179ZM27.2308 15.7313L13.8462 24.7529L2.30769 17.6484V13.5887L13.2692 20.3549C13.5 20.4677 13.7308 20.5804 13.8462 20.5804C14.0769 20.5804 14.3077 20.4677 14.5385 20.3549L26.4231 12.3483C26.3077 13.476 26.5385 14.6036 27.2308 15.7313ZM13.8462 31.5191L2.30769 24.4146V20.3549L13.2692 27.1211C13.5 27.2338 13.7308 27.3466 13.8462 27.3466C14.0769 27.3466 14.3077 27.2338 14.5385 27.1211L26.4231 19.1144C26.3077 20.3549 26.5385 21.5954 27.2308 22.6103L13.8462 31.5191Z"
                                                            fill="#F9F4DD" />
                                                    </svg>
                                                </div>
                                                <div class="text">
                                                    <h5 class="mb-0 f-bold mr-md-3">Dual Pedagogy</h5>
                                                </div>
                                            </div>
                                        </button>
                                    </div>

                                    <div id="DualPedagogy" class="collapse show" aria-labelledby="headingDualPedagogy"
                                        data-parent="#accordionExample2">
                                        <div class="card-body">

                                            <div class="material-tab-content position-relative ">
                                                <p class="f-light mb-2">Listening passively has certain disadvantages because one is not actively involved in the learning process. And as we have limited attention spans, any student will not be able to listen attentively for an extended period of time.</p>
                                                <p class="f-light mb-0">Hence, short attention spans can be increased through iQuanta's dual pedagogy wherein the focus is not only on teaching theoretical concepts but also application-based learning.</p>

                                                <div class="d-flex gap-3 mt-3">
                                                    <div class="img p-0">
                                                        <img class="img-fluid"
                                                            src="https://media.iquanta.in/ui_images/dual-pedagogy-01.webp"
                                                            loading="lazy" alt="CAT Coaching">
                                                    </div>
                                                    <div class="img p-0">
                                                        <img class="img-fluid"
                                                            src="https://media.iquanta.in/ui_images/dual-pedagogy-01.webp"
                                                            loading="lazy" alt="CAT Coaching">
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="headingDoubtSloving">
                                        <button class="btn btn-link btn-block text-left collapsed" type="button"
                                            data-toggle="collapse" data-target="#collapseDoubtSloving"
                                            aria-expanded="false" aria-controls="collapseDoubtSloving">
                                            <div class="d-flex align-items-center">
                                                <div class="icon d-flex align-items-center justify-content-center mr-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                        viewBox="0 0 32 42" fill="none">
                                                        <path
                                                            d="M30.9145 36.4826V42H0.942406V36.4805C0.942406 34.4335 2.73211 31.9096 4.92013 30.8877L9.78834 28.6039L13.167 35.5501L14.8955 30.9232C15.236 30.9889 15.5754 31.0729 15.929 31.0729C16.2837 31.0729 16.622 30.9889 16.9635 30.9232L18.6037 35.324L21.9136 28.5274L26.9368 30.8845C29.1248 31.9096 30.9145 34.4335 30.9145 36.4826ZM15.9301 28.5263C20.2068 28.5263 23.6738 23.2749 23.6738 18.4617C23.6738 13.6442 20.2079 11.0891 15.9301 11.0891C11.6533 11.0891 8.18852 13.6442 8.18852 18.4617C8.18634 23.2749 11.6533 28.5263 15.9301 28.5263ZM27.4988 16.3491L25.8291 15.7816C26.0048 15.2788 26.1587 14.9105 26.2896 14.6736C26.4206 14.4357 26.6236 14.2472 26.8953 14.1083C27.1681 13.9651 27.5566 13.8779 28.0662 13.8413C28.303 13.8348 28.506 13.8284 28.6795 13.823C28.8487 13.8155 29.0015 13.8004 29.1335 13.7756C29.2656 13.7508 29.3823 13.7045 29.4762 13.6399C29.7272 13.4817 29.928 13.1899 30.0742 12.7678C30.263 12.2294 30.299 11.845 30.1844 11.6145C30.1244 11.453 30.0033 11.3195 29.8167 11.2161C29.629 11.1128 29.3441 10.9965 28.9611 10.8673C28.5278 10.7337 28.2026 10.6551 27.9855 10.6261C27.7738 10.597 27.5948 10.625 27.4518 10.7143C27.2991 10.8263 27.1463 11.0578 26.987 11.4132C26.9891 11.4616 26.9749 11.5295 26.9444 11.6156L26.808 12.0032L25.1394 11.4379C25.4046 10.6777 25.672 10.121 25.9426 9.76787C26.2154 9.41576 26.5199 9.20148 26.8593 9.1218C27.2489 9.0292 27.6515 9.02382 28.063 9.10565C28.4733 9.18748 28.9665 9.32639 29.5416 9.52128C30.8272 9.95845 31.5987 10.4861 31.8573 11.1095C32.0887 11.6576 32.0385 12.4027 31.7078 13.3514C31.4776 14.0082 31.2288 14.4615 30.957 14.7092C30.6853 14.9547 30.3492 15.1162 29.9487 15.1916C29.821 15.2174 29.6082 15.24 29.3059 15.254C29.008 15.268 28.7832 15.2799 28.6348 15.296C28.4853 15.31 28.3358 15.352 28.1797 15.4145C27.9866 15.4715 27.8589 15.5598 27.7934 15.6772C27.7203 15.7709 27.621 15.9938 27.4988 16.3491ZM25.3697 17.0932L27.0393 17.6595L26.4195 19.4373L24.7509 18.8709L25.3697 17.0932ZM4.96487 16.0035L3.55166 16.6151C3.36178 16.1887 3.23846 15.8624 3.17954 15.633C3.12279 15.4037 3.13807 15.1625 3.22755 14.9138C3.31704 14.665 3.51565 14.3797 3.81903 14.0577C3.96744 13.9134 4.09512 13.7907 4.20207 13.6873C4.30683 13.5829 4.39632 13.4849 4.46616 13.3912C4.53491 13.2965 4.58074 13.1995 4.60475 13.1026C4.67132 12.8528 4.62439 12.547 4.46616 12.1928C4.26209 11.7351 4.05474 11.4659 3.84085 11.3863C3.70662 11.3163 3.5473 11.3033 3.36505 11.3464C3.18281 11.3884 2.93072 11.481 2.60552 11.6221C2.24649 11.7922 1.99004 11.9322 1.83507 12.0388C1.68011 12.1465 1.58299 12.2681 1.5437 12.4092C1.51424 12.5686 1.55462 12.8108 1.66702 13.1306C1.69866 13.1597 1.73031 13.2125 1.76305 13.2868L1.90928 13.6173L0.496071 14.23C0.210155 13.5861 0.0475541 13.0725 0.0104505 12.6848C-0.0277444 12.2994 0.038824 11.9828 0.209064 11.7319C0.405495 11.4444 0.659764 11.2075 0.974053 11.0191C1.28725 10.8317 1.68775 10.6336 2.17556 10.4193C3.26356 9.94769 4.07766 9.8357 4.61894 10.0834C5.09583 10.2987 5.5127 10.8091 5.86955 11.6113C6.11836 12.1701 6.22967 12.6062 6.20239 12.9239C6.17511 13.2405 6.05725 13.5398 5.84554 13.8241C5.77788 13.9178 5.65347 14.0577 5.46905 14.2408C5.28462 14.4238 5.15039 14.5649 5.062 14.6618C4.97469 14.7587 4.90267 14.8739 4.84156 15.0064C4.75207 15.1539 4.72261 15.2842 4.75098 15.3983C4.7608 15.5028 4.83065 15.703 4.96487 16.0035ZM4.04383 17.7274L5.45813 17.1136L6.12927 18.62L4.71497 19.2305L4.04383 17.7274ZM14.4568 7.28483L12.8668 6.51709C13.1037 6.03792 13.3023 5.68797 13.4627 5.46723C13.622 5.24865 13.849 5.08498 14.136 4.9773C14.4241 4.86747 14.8235 4.82763 15.3342 4.85455C15.5721 4.87716 15.7762 4.89547 15.9465 4.91269C16.1167 4.92669 16.2706 4.92992 16.4059 4.91915C16.5412 4.91054 16.6601 4.87716 16.7649 4.82871C17.0366 4.69842 17.2724 4.43461 17.4699 4.03405C17.7231 3.52043 17.8104 3.1414 17.7209 2.8959C17.6838 2.729 17.5768 2.5804 17.4044 2.45442C17.232 2.33059 16.9624 2.17877 16.5969 2.00218C16.1822 1.81697 15.8679 1.70176 15.6584 1.64361C15.4499 1.59085 15.2688 1.59516 15.1149 1.66622C14.9501 1.7599 14.7679 1.9731 14.566 2.31013C14.5638 2.35859 14.5409 2.42212 14.4994 2.50718L14.315 2.87759L12.7239 2.11093C13.0829 1.38626 13.4201 0.865104 13.7322 0.548532C14.0487 0.228731 14.3783 0.0521397 14.7253 0.0166062C15.1258 -0.0275415 15.5263 0.0166062 15.9246 0.145819C16.3229 0.278262 16.7966 0.477465 17.3466 0.740198C18.571 1.3335 19.2738 1.95372 19.456 2.60302C19.6153 3.17263 19.4757 3.91129 19.026 4.81794C18.715 5.44247 18.4106 5.86349 18.1083 6.07561C17.8082 6.28666 17.4535 6.40833 17.0443 6.43525C16.9111 6.44602 16.6962 6.44171 16.395 6.41695C16.0949 6.39326 15.8712 6.38034 15.7216 6.37603C15.571 6.37065 15.415 6.39756 15.2524 6.44387C15.056 6.47186 14.9163 6.54616 14.8355 6.65599C14.7515 6.73459 14.6271 6.94672 14.4568 7.28483ZM12.247 7.76614L13.8392 8.53281L12.9989 10.2276L11.4067 9.45883L12.247 7.76614Z"
                                                            fill="#F9F4DD" />
                                                    </svg>
                                                </div>
                                                <div class="text">
                                                    <h5 class="mb-0 f-bold">24*7 Doubt Solving</h5>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div id="collapseDoubtSloving" class="collapse"
                                        aria-labelledby="headingDoubtSloving" data-parent="#accordionExample2">
                                        <div class="card-body">
                                            <div class="material-tab-content position-relative ">
                                                <div class="d-flex gap-3 mt-3">
                                                    <div class="img p-0">
                                                        <img class="img-fluid"
                                                            src="https://media.iquanta.in/ui_images/home-image/doubt-solving-24-7.webp"
                                                            loading="lazy" alt="CAT Coaching">
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="headingContentRelavancy">
                                        <button class="btn btn-link btn-block text-left collapsed" type="button"
                                            data-toggle="collapse" data-target="#collapseContentRelavancy"
                                            aria-expanded="false" aria-controls="collapseContentRelavancy">
                                            <div class="d-flex align-items-center">
                                                <div class="icon d-flex align-items-center justify-content-center mr-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                        viewBox="0 0 30 30" fill="none">
                                                        <path
                                                            d="M20.8421 17.02H17.4919C14.7439 17.02 12.5053 14.908 12.5053 12.2827V9.1C12.5053 8.49867 11.9958 8 11.3474 8H6.45333C2.88702 8 0 10.2 0 14.1307V23.8693C0 27.8 2.88702 30 6.45333 30H15.5467C19.113 30 22 27.8 22 23.8693V18.12C22 17.504 21.4751 17.02 20.8421 17.02Z"
                                                            fill="#F9F4DD" />
                                                        <path
                                                            d="M23.5421 0H20.4986H18.8146H14.4424C10.9508 0 8.1236 2.20947 8 6.15277C8.0927 6.15277 8.16994 6.13742 8.26264 6.13742H12.6349H14.3189H17.3624C20.9312 6.13742 23.8202 8.43896 23.8202 12.551V15.5737V19.7318V22.7545C23.8202 22.8466 23.8048 22.9233 23.8048 23C27.25 22.8926 30 20.6217 30 16.6171V13.5944V9.43629V6.41361C30 2.30153 27.111 0 23.5421 0Z"
                                                            fill="#F9F4DD" />
                                                        <path
                                                            d="M15.3155 8.20255C14.83 7.77771 14 8.0655 14 8.6548V12.2454C14 13.7529 15.4564 14.9863 17.2417 14.9863C18.3536 15 19.904 15 21.2351 15C21.9085 15 22.253 14.3148 21.7832 13.9036C20.0762 12.4098 17.0381 9.73747 15.3155 8.20255Z"
                                                            fill="#F9F4DD" />
                                                    </svg>
                                                </div>
                                                <div class="text">
                                                    <h5 class="mb-0 f-bold">Content Relevancy</h5>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div id="collapseContentRelavancy" class="collapse"
                                        aria-labelledby="headingContentRelavancy" data-parent="#accordionExample2">
                                        <div class="card-body">
                                            <div class="material-tab-content position-relative ">
                                                <p class="f-light mb-2">Content Relevancy is one of the biggest features of iQuanta. Over the years, it has been observed CUET pattern is changing; therefore, in combination with CUET Toppers and iQuanta CUET Faculty, we aim for the most effective content provided to students. </p>

                                                <div class="d-flex gap-3 mt-3">
                                                    <div class="img p-0">
                                                        <img class="img-fluid"
                                                            src="https://media.iquanta.in/ui_images/home-image/content-relevancy.webp"
                                                            loading="lazy" alt="CAT Coaching">
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="headingPeertoPeer">
                                        <button class="btn btn-link btn-block text-left collapsed" type="button"
                                            data-toggle="collapse" data-target="#collapsePeertoPeet"
                                            aria-expanded="false" aria-controls="collapsePeertoPeet">
                                            <div class="d-flex align-items-center">
                                                <div class="icon d-flex align-items-center justify-content-center mr-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                        viewBox="0 0 30 30" fill="none">
                                                        <path
                                                            d="M20.8421 17.02H17.4919C14.7439 17.02 12.5053 14.908 12.5053 12.2827V9.1C12.5053 8.49867 11.9958 8 11.3474 8H6.45333C2.88702 8 0 10.2 0 14.1307V23.8693C0 27.8 2.88702 30 6.45333 30H15.5467C19.113 30 22 27.8 22 23.8693V18.12C22 17.504 21.4751 17.02 20.8421 17.02Z"
                                                            fill="#F9F4DD" />
                                                        <path
                                                            d="M23.5421 0H20.4986H18.8146H14.4424C10.9508 0 8.1236 2.20947 8 6.15277C8.0927 6.15277 8.16994 6.13742 8.26264 6.13742H12.6349H14.3189H17.3624C20.9312 6.13742 23.8202 8.43896 23.8202 12.551V15.5737V19.7318V22.7545C23.8202 22.8466 23.8048 22.9233 23.8048 23C27.25 22.8926 30 20.6217 30 16.6171V13.5944V9.43629V6.41361C30 2.30153 27.111 0 23.5421 0Z"
                                                            fill="#F9F4DD" />
                                                        <path
                                                            d="M15.3155 8.20255C14.83 7.77771 14 8.0655 14 8.6548V12.2454C14 13.7529 15.4564 14.9863 17.2417 14.9863C18.3536 15 19.904 15 21.2351 15C21.9085 15 22.253 14.3148 21.7832 13.9036C20.0762 12.4098 17.0381 9.73747 15.3155 8.20255Z"
                                                            fill="#F9F4DD" />
                                                    </svg>
                                                </div>
                                                <div class="text">
                                                    <h5 class="mb-0 f-bold">Peer to Peer Learning</h5>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div id="collapsePeertoPeet" class="collapse" aria-labelledby="headingPeertoPeer"
                                        data-parent="#accordionExample2">
                                        <div class="card-body">
                                            <div class="material-tab-content position-relative ">
                                                <p class="f-light mb-2">A community is very important as having a dedicated community at one place will provide you with the necessary support for your preparation.

                                                </p>

                                                <div class="d-flex gap-3 mt-3">
                                                    <div class="img p-0">
                                                        <img class="img-fluid"
                                                            src="https://media.iquanta.in/ui_images/home-image/peer-to-peer-learning.webp"
                                                            loading="lazy" alt="CAT Coaching">
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="faqs">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="head-mid">
                    <h2>Frequently Asked Questions </h2>
                </div>
            </div>
        </div>
        <div class="gradent-bg">
            <div class="faqs-list">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="faqcard">
                            <ul id="accordion" class="accordion">
                                <li *ngFor="let menu of faqList; let i = index">
                                    <div class="menu" (click)="toggle(i)">
                                        <h3>
                                            <span>Q{{i+1}}.</span> {{ menu.name }}
                                        </h3>
                                        <i class="fa fa-plus" *ngIf="!menu.active"></i>
                                        <i class="fa fa-minus" aria-hidden="true" *ngIf="menu.active"></i>
                                    </div>
                                    <div class="submenu" #submenu
                                        [style.height.px]="menu.active ? submenu.scrollHeight : 0">
                                        <div class="acco_info">
                                            <div *ngFor="let submenu of menu.submenu">
                                                <p>{{ submenu.answer }}</p>
                                                <p *ngFor="let subanswer of submenu.subanswers">{{subanswer}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer-sticky-menu">
    <ul class="footer-icon-menu">
        <li (click)="goToSection('course')">
            <div class="foot-nav">
                <img src="https://media.iquanta.in/ui_images/new-home/Courses.webp" alt="CUET Online Coaching">
                <span>Courses</span>
            </div>
        </li>

        <li [routerLink]="'/cuet-mock-test'">
            <div class="foot-nav">
                <img src="https://media.iquanta.in/ui_images/new-home/Mock.webp" alt="CUET Online Coaching">
                <span>Mocks & Past Papers </span>
            </div>
        </li>

        <li [routerLink]="'/cuet-results'">
            <div class="foot-nav">
                <img src="https://media.iquanta.in/ui_images/new-home/Result.webp" alt="CUET Online Coaching">
                <span>Result</span>
            </div>
        </li>

        <li (click)="openBlog ('https://www.iquanta.in/blog/category/after-12th/cuet-exam/')">
            <div class="foot-nav">
                <img src="https://media.iquanta.in/ui_images/new-home/Blog.webp" alt="CUET Online Coaching">
                <span>Blog</span>
            </div>
        </li>

    </ul>
</div>

<app-footer></app-footer>

<!-- <div class="head-wrapper">
    <div class="icon">
        <img src="" alt="">
    </div>
    <h6>couavhing</h6>
</div> -->